//
//  SDKWorkspaceOnboarding.ts
//  Supernova SDK
//
//  Created by Jiri Trecak.
//
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Object Definition
export class WorkspaceOnboarding {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model) {
        var _a;
        this.supernovaTokenCreated = model.supernovaTokenCreated;
        this.codeExported = model.codeExported;
        this.hookCreated = model.hookCreated;
        this.documentationPublished = model.documentationPublished;
        this.assetsExported = model.assetsExported;
        this.componentCreated = model.componentCreated;
        this.designSystemSourceCreated = (_a = model.designSystemSourceCreated) !== null && _a !== void 0 ? _a : false;
    }
    static initial() {
        return new WorkspaceOnboarding({
            supernovaTokenCreated: false,
            codeExported: false,
            hookCreated: false,
            documentationPublished: false,
            assetsExported: false,
            componentCreated: false,
            designSystemSourceCreated: false,
        });
    }
    // --- --- --- --- --- --- --- --- --- ---
    // MARK: - Serialization & Deserialization
    /** Constructs directly manipulable update object for workspace onboarding */
    toUpdateObject() {
        return {
            supernovaTokenCreated: this.supernovaTokenCreated,
            codeExported: this.codeExported,
            hookCreated: this.hookCreated,
            documentationPublished: this.documentationPublished,
            assetsExported: this.assetsExported,
            componentCreated: this.componentCreated,
            designSystemSourceCreated: this.designSystemSourceCreated,
        };
    }
    /** Constructs representation that can be used to write full object to remote */
    toRemote() {
        return {
            supernovaTokenCreated: this.supernovaTokenCreated,
            codeExported: this.codeExported,
            hookCreated: this.hookCreated,
            documentationPublished: this.documentationPublished,
            assetsExported: this.assetsExported,
            componentCreated: this.componentCreated,
            designSystemSourceCreated: this.designSystemSourceCreated,
        };
    }
    /** Constructs representation that can be used to transport the instantiated object as JSON, for example for SSR <> Client use-cases. Reconstruct to class instance using `fromTransport` */
    toTransport() {
        return this.toRemote();
    }
    /** Reconstructs class from the transport model */
    static fromTransport(model) {
        return new WorkspaceOnboarding(model);
    }
}
